import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DrawingExportKind } from '../../../../../../../../shared/models/drawing-sheet';

/** Export: the current set, or the as-built record set (spec §15 rule 8). Closes with the choice, or nothing on Cancel. */
@Component({
  selector: 'app-drawing-export-dialog',
  templateUrl: './drawing-export-dialog.component.html',
  styleUrls: ['./drawing-export-dialog.component.scss'],
  standalone: false,
})
export class DrawingExportDialogComponent {
  kind: DrawingExportKind = 'current';

  constructor(private ref: MatDialogRef<DrawingExportDialogComponent, DrawingExportKind | null>) {}

  export(): void {
    this.ref.close(this.kind);
  }

  cancel(): void {
    this.ref.close(null);
  }
}
